import React from "react";

import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { updateOrgPool } from "../../../apiclients/streamsapi_bridge";

export default function UnassignPhNumbers({ poolId, setRemovedSuccess, phoneNumber, onClose }) {
    const { t } = useTranslation();
    async function removePhNumber(removedPhNumber) {
        try {

            let updateJSON = {
                reqid: 115,
                poolid: poolId,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                remove_dids: [parseInt(removedPhNumber)]
            };
            console.log(`UpdateJSONInof:::${JSON.stringify(updateJSON)}`);
            let apiResponse = await updateOrgPool(updateJSON);
            console.log(`status::${apiResponse.status} ::`);
            if (apiResponse.status == 200) {
                let apiData = await apiResponse.json();
                localStorage.setItem("s_message", apiData.message);
                setRemovedSuccess(true);
                onClose();

            } else {
                //  setErrorMessage('Unable to process the request.');
                localStorage.setItem(
                    "f_message",
                    "Something went wrong, Please try again after sometime"
                );
            }
            window.location.href = "/pooledit";

        } catch (e) {
            console.log(`Org Info not available:${e}`);
        }
    }
    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 mb-3 rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="unlink" className="me-3" size="lg" color="danger" />
                <span>{t("UnassingPhonetxt")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={() => { onClose(); }}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => { removePhNumber(phoneNumber); onClose(); }} >{t("unassign")}</MDBBtn>
            </MDBModalFooter>

        </>
    );
};

